export default {
  title: 'Bedrijfsoverzicht',
  description: 'Welkom terug, {{name}}! Dit is wat er speelt bij uw marketing.',
};
